import { FC, useEffect } from "react"
import { useHistory } from "react-router-dom";

import { LOGOUT_TIMER } from "../../utils/env";

export class AppData {
    public static timer: any;
    public static onLogout(history: any) {
        const masterId = localStorage.getItem("masterID");
        const agentName = localStorage.getItem("agentName");
        let agentNameQueryString = "";
        localStorage.clear();
        if (agentName) {
            agentNameQueryString = `&agentName=${agentName}`;
        }
        history.push(`/signin?masterID=${masterId}${agentNameQueryString}`);
    }
}
const LogoutManager: FC = () => {
    const history = useHistory();  
    const events = [
        "load",
        "mousemove",
        "mousedown",
        "click",
        "scroll",
        "keypress"
    ];

    useEffect(() => {
        setEvent();
    }, []);

    const setEvent = () => {
        setNewTimeout();
        for (let i in events) {
            window.addEventListener(events[i], resetTimer);
        }
    }

    const resetTimer = () => {
        clearTimer();
        setNewTimeout();
    }

    const clearTimer = () => {
        if (AppData.timer) {
            clearTimeout(AppData.timer);
            AppData.timer = null;
        }
    };

    const setNewTimeout = () => {
        AppData.timer = setTimeout(() => {
            if (window.location.pathname !== "/signin") { 
                AppData.onLogout(history);
            }            
        }, LOGOUT_TIMER);
    }
    return (<></>)
}

export default LogoutManager;